module.exports = "<areas-form [area]=land title=\"Edit Area\" [onSubmit]=\"onSubmit.bind(this)\" key=\"edit\"></areas-form>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/areas/edit/edit.component.html
// module id = ../../../../../src/app/components/areas/edit/edit.component.html
// module chunks = main